import { canNavigate, hasArea, routeAreas } from '@/lib/navigation';
import { forwardRef } from "react";
import { NavLink } from "react-router-dom";
import { LockKeyhole } from "lucide-react";
import { showLockedArea } from "./LockedAreaDialog";
import { useAuth } from "@/context/AuthContext";
import "./AreaNavLink.css";

export const LOCKED_AREA_MESSAGE = "Dieser Bereich ist für dich noch nicht freigeschaltet.";

// A locked area is a button without a destination, so new-tab and keyboard
// activation cannot bypass the existing route and server access checks.
const AreaNavLink = forwardRef(function AreaNavLink({ to, area, children, className, onClick, ...props }, ref) {
  const { user } = useAuth();
  const locked = area ? !hasArea(user,area) : !canNavigate(user,to);
  if (!locked) return <NavLink ref={ref} to={to} className={className} onClick={onClick} {...props}>{children}</NavLink>;
  const state = { isActive: false, isPending: false, isTransitioning: false };
  return <button {...props} ref={ref} type="button" aria-disabled="true" title={LOCKED_AREA_MESSAGE}
    className={`${typeof className === "function" ? className(state) : className || ""} area-nav-locked`}
    onClick={() => showLockedArea(area || routeAreas(to)[0])}>
    {typeof children === "function" ? children(state) : children}
    <LockKeyhole aria-hidden="true" className="area-nav-lock" />
    <span className="sr-only"> – Nicht freigeschaltet</span>
  </button>;
});
export default AreaNavLink;
